export const SERVER_URL = import.meta.env.VITE_SERVER_URL
export const BROKER_URL = import.meta.env.VITE_BROKER_URL

// -----------------------------------------------------------------------------
// MQTT CONFIG
// -----------------------------------------------------------------------------
// Data topic structure: base/group/client-id/data/domain
// Command topic structure: base/group/client-id/cmd/domain/action
export const MQTT_BASE_TOPIC = 'BASE-TOPIC-PLACEHOLDER'
export const CLIENT_ID = `CLIENT-ID-PLACEHOLDER`

export const MQTT_USERNAME = import.meta.env.VITE_MQTT_USERNAME
export const MQTT_PASSWORD = import.meta.env.VITE_MQTT_PASSWORD

export const MQTT_OPTIONS = [
  { header: 'RFID' },
  {
    name: 'Tap to Start',
    payload: {
      minor: false,
      result: 'Authorized',
      seapass_id: '04 6F CB DA FB 6C 81',
      tax_rate: 0,
    },
    topic: `${MQTT_BASE_TOPIC}/photobooth/app/cmd/start`,
  },
  { divider: true },
  { header: 'Motor Control Commands' },
  {
    name: 'Motor Control - Open Door',
    payload: {},
    topic: `${MQTT_BASE_TOPIC}/motor-control/door/cmd/open`,
  },
  {
    name: 'Motor Control - Close Door',
    payload: {},
    topic: `${MQTT_BASE_TOPIC}/motor-control/door/cmd/close`,
  },
]
